/**
 * Carousel component — Alpine.js data + Slick (vanilla fork).
 *
 * @requires ./slick.js
 */

import Alpine from 'alpinejs';

( () => {

	document.addEventListener( 'alpine:init', () => {

		Alpine.data( 'slick', () => ({

			get sliderEl() {
				return this.$el;
			},

			get slidesEl() {
				return this.$el.querySelector( '.slides' );
			},

			get sliderName() {
				return this.$el.dataset.slick;
			},

			init() {
				const options = {
					appendArrows: this.sliderEl.nextElementSibling?.querySelector( '.slick-arrows-container' ) ?? this.sliderEl.querySelector( '.slick-arrows-container' ),
					appendDots  : this.sliderEl.querySelector( '.slick-dots-container' ),
					mobileFirst : true,
				};

				if ( window.matchMedia( '( prefers-reduced-motion: reduce )' ).matches ) {
					options.fade = true;
				}

				switch ( this.sliderName ) {

				case 'testimonials':
					options.arrows         = true;
					options.dots           = false;
					options.infinite       = false;
					options.prevArrow      = '<button class="prev slick-prev" type="button" aria-label="Previous"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M15 18l-6-6 6-6"/></svg></button>';
					options.nextArrow      = '<button class="next slick-next" type="button" aria-label="Next"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M9 18l6-6-6-6"/></svg></button>';
					options.slidesToScroll = 1;
					options.slidesToShow   = 1;
					options.responsive     = [
						{
							breakpoint: '48em',
							settings  : {
								slidesToShow: 2,
							},
						},
						{
							breakpoint: '64em',
							settings  : {
								slidesToShow: 3,
							},
						},
					];
					break;

				}

				this.slidesEl.addEventListener( 'init', () => window.dispatchEvent( new Event( 'resize' ) ) );
				this.slidesEl.slick = slickInit( this.slidesEl, options );
				this.sliderEl.classList.remove( 'opacity-0' );
			},

			unpause() {
				this.slidesEl.slick.play();
			},

		}) );

	});

})();
